"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareAltiumNetNameCaseVariants = compareAltiumNetNameCaseVariants;
exports.compareAltiumNetNameCandidates = compareAltiumNetNameCandidates;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
function compareAltiumNetNameCaseVariants(a, b) {
    if (a === b) {
        return 0;
    }
    return a > b ? -1 : 1;
}
function compareAltiumNetNameCandidates(a, b) {
    if (a.toLowerCase() === b.toLowerCase()) {
        return compareAltiumNetNameCaseVariants(a, b);
    }
    return sigma_engine_shared_1.Utils.naturalStringSort(a, b);
}
//# sourceMappingURL=AltiumNetNameCaseSelection.js.map